import { useCallback } from 'react';
import TableBody from '@mui/material/TableBody';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import { codelists } from 'constants/codelists';
import fetch from 'features/common/fetch';
import taskSearch from 'features/views/taskSearch';
import { getCodelistByName } from 'utils/codelists';

import ResultsTableRow from './ResultsTableRow';

export const ResultsTableBody = () => {
	const tasks = useSelector(taskSearch.selectors.getTasks);
	const fetchState = useSelector(fetch.selectors.getFetchState(fetch.constants.urls.taskList));

	const taskTypesCodelist = useSelector(getCodelistByName(codelists.taskTypes));
	const taskStatusCodelist = useSelector(getCodelistByName(codelists.taskStatus));
	const finishTypesAllCodelist = useSelector(getCodelistByName(codelists.finishTypesAll));

	const renderRow = useCallback(
		(task) => (
			<ResultsTableRow
				key={task.id}
				task={task}
				taskTypesCodelist={taskTypesCodelist}
				taskStatusCodelist={taskStatusCodelist}
				finishTypesAllCodelist={finishTypesAllCodelist}
			/>
		),
		[taskTypesCodelist, taskStatusCodelist, finishTypesAllCodelist],
	);

	return (
		<TableBody>{isEmpty(tasks) ? <TableHasNoResults fetchState={fetchState} /> : tasks.map(renderRow)}</TableBody>
	);
};

export default ResultsTableBody;
